module.exports = "<img src=\"/assets/images/nemmadi_logo.png\" title=\"Home\">\r\n"